<template>
  <v-navigation-drawer
    id="LeftSideDrawer"
    app
    v-model="drawer"
    fixed
    :temporary="drawer"
    width="280"
  >
    <v-img :aspect-ratio="16 / 9" position="top left" src="/static/logo/8.jpg">
      <v-layout pa-2 column fill-height class="lightbox white--text">
        <v-spacer></v-spacer>
        <v-flex
          md4
          sm4
          xs4
          class="text-xs-center"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <img
            v-if="getLogoImage != null && getLogoImage != ''"
            v-bind:src="getLogoImage"
            height="100"
            width="130"
            alt="Vue Material Admin Template"
          />
          <v-avatar v-else :size="70" color="white">
            <span class="black--text" style="font-size: 60px">
              <strong>{{ this.company_name.toString().charAt(0) }}</strong>
            </span>
          </v-avatar>
        </v-flex>
        <v-flex
          md8
          sm8
          xs8
          class="text-xs-center"
          style="margin-top: 5px; margin-bottom: 10px"
        >
          <p
            class="text-xs-center"
            style="font-size: 25px; cursor: pointer"
            @click="_verifyDb()"
          >
            <strong>{{ this.company_name }}</strong>
          </p>
          <hr
            class="text-xs-center"
            style="margin-top: -10px; margin-left: 8px; margin-right: 8px"
          />
          <p
            class="text-xs-center"
            style="font-size: 15px; font-size: 15px; margin-bottom: 0px"
          >
            <strong>{{ this.userCode }}</strong>
          </p>
          <!-- <v-layout align-center justify-space-around style="margin-left:20px;margin-top:10px;">
              <v-icon small @click="goto('/profile')">fas fa-user</v-icon>
              <v-icon small @click="goto('/notification')">fas fa-bell</v-icon>
              <v-icon small @click="goto('/settings')">fas fa-cog</v-icon>
              <v-icon small @click="logout()">fas fa-sign-out-alt</v-icon>
          </v-layout>-->
        </v-flex>
      </v-layout>
    </v-img>
    <v-toolbar color="blue darken-1" class="coco-logo" dark style="back">
      <!-- <template>
        <v-layout row wrap>
          <v-flex xs12>
            <v-flex row pt-2 align-center justify-center text-xs-center>
              <v-flex xs12>
                <v-avatar color="purple lighten-2" size="75">
                  <v-icon dark style="font-size:5em;">account_circle</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs12 pt-2 pb-4>
                <h4>{{this.userCode}}</h4>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
      </template>-->
      <!-- <v-toolbar-title class="ml-0 pl-3">
        <span>COCO PAYDAY</span>
      </v-toolbar-title>-->
    </v-toolbar>
    <vue-perfect-scrollbar
      class="drawer-menu--scroll"
      :settings="scrollSettings"
    >
      <v-list dense expand>
        <v-list-group class="font_menu" prepend-icon="fa-user" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ $t("menu.account") }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="(item, index) in items"
            :key="index"
            :to="item.url"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{
                $t("menu." + item.title)
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()">
            <v-list-tile-content>
              <v-list-tile-title>{{ $t("menu.logout") }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <!-- Language Menu -->
        <v-list-group
          class="font_menu"
          prepend-icon="fa-globe-americas"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{
                $t("l." + this.currentLang)
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="(item, index) in this.languages"
            :key="index"
            @click="switchLang(item.code)"
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title" />
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <template v-for="(item, i) in menus">
          <!--group with subitems-->
          <v-list-group
            class="font_menu"
            v-if="item.items"
            :key="item.name"
            :group="item.group"
            :prepend-icon="item.icon"
            no-action="no-action"
            v-model="item.active"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("menu." + item.title)
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--sub group-->
              <v-list-group
                class="font_menu"
                v-if="subItem.items"
                :key="subItem.name"
                :group="subItem.group"
                sub-group="sub-group"
              >
                <v-list-tile slot="activator" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-for="(grand, i) in subItem.children"
                  :key="i"
                  :to="genChildTarget(item, grand)"
                  :href="grand.href"
                  ripple="ripple"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $t("menu." + grand.title)
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!--child item-->
              <v-list-tile
                class="font_menu"
                v-else
                :key="i"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                ripple="ripple"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ $t("menu." + subItem.title) }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{
                    subItem.action
                  }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-subheader v-else-if="item.header" :key="i">{{
            item.header
          }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="i+'d'"></v-divider>
          <!--top-level link-->
          <v-list-tile
            class="font_menu"
            v-else
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="item.name+'n'"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{
                $t("menu." + item.title)
              }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
        <!-- user menu -->
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
/* eslint-disable */
import menu from "@/api/menu.js";
import menuEmp from "@/api/menuEmp.js";
import { mapState, mapActions, mapMutations } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
export default {
  name: "app-left-side-drawer",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    mini: false,
    drawer: true,
    menus: "",
    user: "",
    userCode: localStorage._usercode.toString(),
    empCode: localStorage._empcode,
    scrollSettings: {
      maxScrollbarLength: 160,
    },
    companyname: " ",
    company_name: localStorage._company_name,
    currentLang: {},
    languages: [],
    items: [],
    permission: [],
    menu: [],
    itemAdmin: [
      {
        title: "profile",
        icon: "person",
        url: "/profile",
      },
      /*{
        title: "settings",
        icon: "settings",
        url: "/settings"
      }*/
    ],
    itemEmp: [
      {
        title: "profile",
        icon: "person",
        url: "/emp/profile",
      },
      /*{
        title: "settings",
        icon: "settings",
        url: "/settings"
      }*/
    ],
    img: "",
    check_user: 0,
    Menu: [
      {
        divider: true,
      },

      {
        title: "Dashboard",
        group: "apps",
        icon: "dashboard",
        name: "Dashboard",
      },
      // {
      //   title: "EmployeeList",
      //   group: "apps",
      //   icon: "assignment_ind",
      //   name: "EmployeeList",
      // },
      // {
      //   title: "Employeeinactive",
      //   group: "apps",
      //   icon: "person",
      //   name: "Employeeinactive",
      // },
      {
        title: "ManageEmployee",
        group: "ManageEmployee",
        icon: "person",
        items: [
          {
            name: "EmployeeList",
            title: "EmployeeList",
          },
          {
            name: "Employeeinactive",
            title: "Employeeinactive",
          },
          {
            name: "SetemployeeleaveList",
            title: "SetemployeeleaveList",
          },
        ],
      },
      {
        title: "ImportFile",
        group: "ImportFile",
        icon: "save_alt",
        items: [
          {
            name: "IncomeDocList",
            title: "ImportFileIncome",
          },
          {
            name: "ExpensedDocList",
            title: "ImportFileExpensed",
          },
          {
            name: "ImportFingerScan",
            title: "ImportFingerScan",
          },
          // {
          //     name: 'ImportTimeAttendance',
          //     title: "ImportTimeAttendance"
          // },
        ],
      },

      {
        title: "เพิ่มเอกสารร้องขอ",
        group: "เพิ่มเอกสารร้องขอ",
        icon: "insert_drive_file",
        items: [
          {
            name: "ExpensedList",
            title: "ExpensedList",
          },
          {
            name: "IncomeList",
            title: "IncomeList",
          },
          // {
          //     name: 'IncomeList',
          //     title: "IncomeList"
          // },

          {
            name: "CheckInOutList",
            title: "CheckInOutList",
          },

          // ใหม่
          {
            name: "TakeLeaveList",
            title: "TakeLeaveList",
          },
          // ใหม่
          {
            name: "ChangePlanList",
            title: "ChangePlanList",
          },
          // ใหม่
          {
            name: "OTPlanList",
            title: "OTPlanList",
          },
          {
            name: "ReSignList",
            title: "ReSignList",
          },
          {
            name: "ChangeSalaryList",
            title: "ChangeSalaryList",
          },
          {
            name: "CommissionList",
            title: "CommissionList",
          },

          // {
          //     name: 'TimeAttendanceList',
          //     title: "TimeAttendanceList"
          // },
        ],
      },
      
      {
        title: "แผนงานและเวลาทำงาน",
        group: "แผนงานและเวลาทำงาน",
        icon: "av_timer",
        items: [
          {
            name: "ChangeWorkplanList",
            title: "ChangeWorkplanList",
          },

          {
            name: "CheckInList",
            title: "CheckInList",
          },
          // {
          //     name: 'CheckInTableList',
          //     title: "CheckInTableList"
          // },
          {
            name: "TimeCheckList",
            title: "TimeCheckList",
          },
          {
            name: "WorkPlanByEMPList",
            title: "WorkPlanByEMPList",
          },
        ],
      },
      {
        title: "เงินเดือนและการจ่ายเงิน",
        group: "เงินเดือนและการจ่ายเงิน",
        icon: "attach_money",
        items: [
          {
            name: "SalaryTableList",
            title: "SalaryTableList",
          },
          {
            name: "PayRollDocumentList",
            title: "PayRollDocumentList",
          },
        ],
      },
      {
        title: "Report",
        group: "Report",
        icon: "file_copy",
        items: [
          // {
          //   name: "PNDForm",
          //   title: "PNDForm",
          // },
          {
            name: "WithholdingTaxForm",
            title: "WithholdingTaxForm",
          },
          {
            name: "WithholdingTaxCertificate",
            title: "WithholdingTaxCertificate",
          },
            {
                name: 'SocialSecurityKor20',
                title: 'SocialSecurityKor20'
            }
          //  {
          //     name:'BalanceOfLeave',
          //     title:'BalanceOfLeave'
          // },
          // {
          //     name:'CumulativeIncome',
          //     title:'CumulativeIncome'
          // }
        ],
      },
      {
        title: "ตั้งค่าทั่วไป",
        group: "ตั้งค่าทั่วไป",
        icon: "settings",
        items: [
          // {
          //   name: "HolidayList",
          //   title: "HolidayList",
          // },
          // {
          //     name: 'HolidayInYear',
          //     title: "HolidayInYear"
          // },
          {
            name: "BranchList",
            title: "BranchList",
          },
          {
            name: "DepartmentList",
            title: "DepartmentList",
          },
          // ใหม่
          {
            name: "WorkPlanList",
            title: "WorkPlanList",
          },
          // ใหม่
          {
            name: "ConditionsList",
            title: "ConditionsList",
          },
          {
            name: "CompanyAddress",
            title: "CompanyAddress",
          },
          {
            name: "GeneralSetting",
            title: "GeneralSetting",
          },
          {
            name: "TaxSettingList",
            title: "TaxSettingList",
          },
          // {
          //     name: 'DecimalSetting',
          //     title: "DecimalSetting"
          // },
          {
            name: "DeviceSettingList",
            title: "DeviceSettingList",
          },
          {
            name: "MappingDeviceSettingList",
            title: "MappingDeviceSettingList",
          },

          // {
          //   name: "PlansCompany",
          //   title: "PlansCompany"
          // }
        ],
      },
      {
        title: "ImportFile_Master",
        group: "ImportFile_Master",
        icon: "save_alt",
        items: [
          {
            name: "ImportEmployee",
            title: "ImportEmployee",
          },
          {
            name: "ImportDepartment",
            title: "ImportDepartment",
          },
          {
            name: "ImportBranch",
            title: "ImportBranch",
          },
        ],
      },
      // {
      //   title: "Permissions",
      //   group: "Permissions",
      //   icon: "done",
      //   items: [
      //     {
      //       name: "IndividualPermissionsList",
      //       title: "IndividualPermissionsList",
      //     },
      //     {
      //       name: "GroupPermissionsList",
      //       title: "GroupPermissionsList",
      //     },
      //   ],
      // },
      {
        title: "ShopSetting",
        group: "apps",
        icon: "store",
        name: "ShopSetting",
      },
    ],
  }),
  watch: {
    // $route(route) {
    //   console.log(route.name);
    //   for (let index = 0; index < this.menus.length; index++) {
    //     const main_data = this.menus[index];
    //     if (main_data.items != undefined) {
    //       main_data.items.forEach(sub_data => {
    //         // this.menus[index].active = sub_data.name == route.name ? true : false;
    //         if (sub_data.name == route.name) {
    //           this.menus[index].active = true;
    //           console.log(this.menus[index].active);
    //         }
    //       });
    //     }
    //   }
    //   // this.menus.forEach(element => {
    //   // });
    // }
  },
  computed: {
    ...mapState("permissionmenu", ["permission_List"]),
    computeGroupActive() {
      return true;
    },
    getLogoImage() {
      return this.img;
    },
  },
  async created() {
    this.initLang();
    //this.permission = this.permission_List;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        // console.log(res);
      })
      .catch((err) => {});

    (this.user = localStorage._is_admin.toString()),
      await this.checkuser(this.user); //input localStorage._is_admin check user
    await window.getApp.$on("APP_LEFT_DRAWER_TOGGLE", () => {
      this.drawer = !this.drawer;
    });
    SettingService.getCompanyAddress()
      .then((res) => {
        if (res.data.content.length > 0) {
          this.companyname = res.data.content[0].companyname;
          this.img = res.data.content[0].imageLogo;
        } else {
          this.companyname = "";
          this.img = "";
        }
      })
      .catch((err) => {});
  },
  methods: {
    ...mapMutations("filter", ["setlogout"]),
    ...mapMutations("app", ["setApplogout"]),
    ...mapMutations("toolbar", ["setToolbarLogout"]),
    // ...mapMutations("dialog", ["setDialoglogout"]),
    ...mapMutations("auth", ["authlogout"]),
    _verifyDb() {
      UserService.getVerifyDatabase({
        company_guid: localStorage._company_guid,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log("error " + err);
        });
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return {
        name: `${subItem.name}`,
      };
    },

    // check user admin or employee
    checkuser(user) {
      //  console.log("user", user);
      if (user == "true") {
        let menux = [];
        this.Menu.forEach((element) => {
          if (
            localStorage._usercode == "adminsolao" ||
            localStorage._is_timeattendance == 1 ||
            localStorage._usercode == "timeattdemo@cocopayday.com"
          ) {
            menux.push(element);
          } else if (localStorage._is_admin == "true") {
            if (element.title != "แผนงานและเวลาทำงาน") {
              if (element.name != undefined) {
                menux.push(element);
              } else if (element.items != undefined) {
                if (
                  localStorage._is_timeattendance == 0 ||
                  localStorage._is_timeattendance == "null"
                ) {
                  var list = [];
                  var item = [];
                  list.push;
                  element.items.forEach((el) => {
                    if (
                      el.title != "CheckInOutList" &&
                      // el.title != "TakeLeaveList" &&
                      el.title != "ChangePlanList" &&
                      el.title != "OTPlanList" &&
                      el.title != "WorkPlanList" &&
                      el.title != "ConditionsList" &&
                      el.title != "ImportFingerScan" &&
                      el.title != "ImportTimeAttendance" &&
                      el.title != "DeviceSettingList" &&
                      el.title != "CommissionList" &&
                      el.title != "MappingDeviceSettingList"
                    ) {
                      item.push(el);
                    }
                  });
                  list = element;
                  list.items = item;
                  menux.push(list);
                } else {
                  menux.push(element);
                }
              }
            }
          }
        });
        this.menus = menux;
        this.items = this.itemAdmin;
        console.log("true:", user);
      } else if (user == "false") {
        var menu_emp = [];
        //console.log("e", menuEmp);

        // console.log("length", this.permission.length);
        if (this.permission.length > 0) {
          //menu_emp = menuEmp;
          menuEmp.forEach((el) => {
            if (localStorage._is_timeattendance == 1) {
              menu_emp.push(el);
            }
            if (
              localStorage._is_timeattendance == 0 &&
              el.name != "WorkPlanByEMPList"
            ) {
              menu_emp.push(el);
            }
          });

          this.Menu.forEach((itemMenu) => {
            if (itemMenu.name != undefined) {
              if (
                this.getPermission(itemMenu.name) == true &&
                itemMenu.name != "Dashboard" &&
                itemMenu.name != "ShopSetting" &&
                localStorage._is_timeattendance == 1
              ) {
                menu_emp.push(itemMenu);
              }
            }
            if (itemMenu.items != undefined) {
              //console.log("in", menu_emp);
              var list;
              var item = [];
              //console.log("in1", itemMenu.items);
              itemMenu.items.forEach((element) => {
                // console.log("inff", element.name);
                // console.log(this.getPermission(element.name));
                if (localStorage._is_timeattendance == 1) {
                  if (
                    this.getPermission(element.name) == true &&
                    element.name != "WorkPlanByEMPList"
                  ) {
                    item.push(element);
                  }
                }
                if (localStorage._is_timeattendance == 0) {
                  if (
                    this.getPermission(element.name) == true &&
                    element.name != "CheckInOutList" &&
                    element.name != "ChangePlanList" &&
                    element.name != "OTPlanList" &&
                    element.name != "WorkPlanList" &&
                    element.name != "ConditionsList" &&
                    element.name != "ImportFingerScan" &&
                    element.name != "ImportTimeAttendance" &&
                    element.name != "DeviceSettingList" &&
                    element.name != "MappingDeviceSettingList" &&
                    element.name != "CommissionList" &&
                    element.title != "แผนงานและเวลาทำงาน"
                  ) {
                    item.push(element);
                  }
                }
              });
              list = itemMenu;
              list.items = item;
              if (list.items.length > 0) {
                menu_emp.push(list);
              }
            }
            // console.log("in2", itemMenu);
          });
          this.menus = menu_emp;
        } else {
          // console.log("eeee",this.menus);
          this.menus = menuEmp;
        }
        //console.log("eeee",this.menus);
        //this.menus = menu_emp;
        this.items = this.itemEmp;
      }
    },
    getPermission(pagename) {
      var status = true;
      this.permission.forEach((element) => {
        if (element.module_name == pagename) {
          status = element.reads;
        }
      });
      return status;
    },
    initLang() {
      for (let langKey in this.$i18n.messages) {
        this.languages[this.languages.length] = {
          code: langKey,
          title: this.$i18n.messages[langKey].lang,
        };
      }

      if (localStorage.getItem("lang")) {
        this.$i18n.locale = localStorage.getItem("lang");
      }
      this.currentLang = this.$i18n.locale;
    },
    switchLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.currentLang = this.$i18n.locale;
    },
    logout() {
      let v = this;
      sessionStorage.clear();
      localStorage.clear();
      v.setlogout();
      v.setApplogout();
      v.setToolbarLogout();
      //v.setDialoglogout();
      v.authlogout();
      this.$router.push("/login");
    },
  },
};
</script>
<style lang="stylus">
#LeftSideDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 265px);
    overflow: auto;
  }
}
</style>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");
.coco-logo > .v-toolbar__content {
  height: auto !important;
}
.font_menu {
  font-family: "Prompt", sans-serif;
}
</style>